/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import IconBerserkerMail from "./Icon";

export interface Props
  extends DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
  > {
  icon?: string;
}

const CustomButtonWrapper: any = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 6px;
  color: #555555;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 12px;
  cursor: pointer;
`;

const CustomButtonText = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 0.7px;
  color: #555555;
  text-transform: uppercase;
  opacity: 1;
`;

const Icon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 8px;
`;

const IconButton = (props: Props): JSX.Element => {
  const { icon, children } = props;

  return (
    <CustomButtonWrapper {...props}>
      {icon && <IconBerserkerMail name={icon} width={15} height={15} />}
      <CustomButtonText
        css={
          icon &&
          css`
            margin-left: 5px;
          `
        }
      >
        {children}
      </CustomButtonText>
    </CustomButtonWrapper>
  );
};

export default IconButton;
